<template>
  <div>
    <div class="w100 white text-center">
      <template v-if="registered">
        <div class="text-center signup">
          <i class="fa fa-check big-check p-4" />

          <p class="congrat">
            {{ $t("congratulations") | upper }}
          </p>
          <p>{{ $t("regitry_line_1") }}</p>
          <p>{{ $t("regitry_line_2") }}</p>
          <p>{{ $t("regitry_line_3") }}</p>
          <p>{{ $t("regitry_line_4") }}</p>
        </div>
      </template>

      <template v-else>
        <div class="p4 w100 text-center">
          <span class="welcome-to-soundsys text-center pt-4 pl-2 pr-2">{{ $t('new_member_signup') }}</span>
        </div>

        <div class="p4 w100 text-center">
          <span class="please-login-or-sign pl-2 pr-2">{{ $t("signup_header") }}</span>
        </div>

        <b-form @submit.prevent="registerMember">
          <template v-if="societies">
            <div class="p4 w100 text-left displayName">
              <span class="w80 le">{{ $t("society") | capitalize }}:</span>
            </div>

            <div class="w100">
              <Multiselect
                v-model="current_societies"
                placeholder="Select a society"
                :options="societies"
                :multiple="true"
                track-by="name"
                label="name"
                :hide-selected="true"
                :show-labels="false"
              >
                <template v-slot:singleLabel="{ option }">
                  <div class="form_block2 societies space-between">
                    <div style="width:60px; overflow:hidden; margin-right:10px;">
                      <img v-if="imgSrc(option.name)" class="society-logo" :src="imgSrc(option.name)">
                    </div>
                    <div class="option__desc">
                      <span class="option__title">{{ option.name | upper }}</span>
                    </div>
                  </div>
                </template>

                <template v-slot:option="{ option }">
                  <div class="form_block2 societies space-between">
                    <div style="width:60px; overflow:hidden; margin-right:10px;">
                      <img
                        v-if="imgSrc(option.name)"
                        class="society-logo"
                        :src="imgSrc(option.name)"
                      >
                    </div>
                    <div class="option__desc">
                      <span class="option__title">{{ option.name | upper }}</span>
                    </div>
                  </div>
                </template>
              </Multiselect>
            </div>
          </template>

          <transition name="fade">
            <span
              v-for="err in error.parents"
              :key="err"
              class="error"
            >{{ err }}</span>
          </transition>

          <transition name="fade">
            <div
              v-if="error.app"
              class="error p-4"
            >
              <span
                v-for="err in error.app"
                :key="err"
                class="child"
              >{{ err }}</span>
            </div>
          </transition>

          <!--language-->
          <transition name="fade">
            <div
              v-if="showLanguages"
              class="p4 w100 text-left w80"
            >
              <span class="w80 le">{{ $t("language") | capitalize }}:</span>
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="showLanguages"
              class="w80"
            >
              <LanguageSelector :post="false" />
            </div>
          </transition>

          <transition name="fade">
            <span
              v-for="err in error.language"
              :key="err"
              class="error"
            >{{ err }}</span>
          </transition>

          <!--email-->
          <div class="p4 w100 text-left">
            <span class="w80 le">{{ $t("email") | capitalize }}:</span>
          </div>

          <div class="w100">
            <input
              v-model="email"
              class="login w80"
            >
          </div>

          <transition name="fade">
            <span
              v-for="err in error.email"
              :key="err"
              class="error"
            >{{ err }}</span>
          </transition>

          <!--name_and_last_name-->
          <div class="p4 w100 text-left">
            <span class="w80 le">{{ $t("name_and_last_name") | capitalize }}:</span>
          </div>

          <div class="w100">
            <input
              v-model="name_and_last_name"
              class="login w80"
            >
          </div>

          <transition name="fade">
            <span
              v-for="err in error.name_and_last_name"
              :key="err"
              class="error"
            >{{ err }}</span>
          </transition>

          <!--member-->
          <div class="p4 w100 text-left">
            <span class="w80 le">{{ $t("companyName") | capitalize }}:</span>
          </div>

          <div class="w100">
            <input
              v-model="member"
              class="login w80"
            >
          </div>

          <transition name="fade">
            <span
              v-for="err in error.organization"
              :key="err"
              class="error"
            >{{ err }}</span>
          </transition>

          <!--address-->
          <div class="p4 w100 text-left">
            <span class="w80 le">{{ $t("address") | capitalize }}:</span>
          </div>

          <div class="w100">
            <input
              v-model="address"
              class="login w80"
            >
          </div>

          <transition name="fade">
            <span
              v-for="err in error.address"
              :key="err"
              class="error"
            >{{ err }}</span>
          </transition>

          <div class="pb-4 pt-2 w100">
            <button
              type="submit"
              class="btn w80 btns btn-primary"
            >
              <spinner v-if="loading" />
              <span v-else>{{ button_text | capitalize }}</span>
            </button>
          </div>
        </b-form>
      </template>

    </div>
  </div>
</template>


<style lang="scss">
@import "../../../assets/styles/modules/signupDropdowns.scss";
@import "../../../assets/styles/login.scss";
</style>

<style scoped>
input.login {
  height: 40px;
  border: 1px solid #c0c5cf;
  border-radius: 4px;
}

.multiselect {
  width: 80%;
  margin: auto;
}

.w80 {
  width: 80%;
  min-width: 300px;
  margin: auto;
}

.w100 {
  width: 100%;
}

.le {
  padding-left: 10%;
}

.ri {
  padding-right: 10%;
}

.p4 {
  padding-top: 20px;
}

.title-form {
  font-size: 1.5em;
  color: rgb(110, 160, 184);
}

.signup {
  font-family: "proxima_novaregular", sans-serif;
}

.big-check {
  color: greenyellow;
  font-size: 50px;
}

.congrat {
  font-size: 14px;
  font-weight: bold;
}

.word-wrap span {
  overflow-wrap: break-word;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.white {
  background-color: white;
}
</style>


<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex"
import { ApiCalls } from "@/assets/libs/services"
import LanguageSelector from "@/components/Modules/LanguageSelector"
import { remoteImg } from "@/assets/libs/utils"

export default {
  name: "SignUp",
  components: {
    LanguageSelector
  },
  data () {
    return {
      loading: false,
      current_societies: [],
      nationality: "",
      address: "",
      email: "",
      name_and_last_name: "",
      error: "",
      member: "",
      registered: false,
    }
  },
  watch: {
    current_societies (societies) {
      if (societies.length) {
        this.getLanguages(societies)
      } else {
        this.resetLanguages()
      }
    }
  },
  computed: {
    button_text () {
      return this.registered ? this.$t("go_back") : this.$t("sign_up")
    },
    showLanguages () {
      return this.languages.length > 1
    },
    ...mapGetters("members", ["logoSrc", "currentSocietyName"]),
    ...mapState("members", ["languages", "society", "societies", "language"])
  },
  mounted () {
    this.setSociety("")
    this.getSocieties()
    this.resetLanguages()
  },
  methods: {
    ...mapActions("members", ["getSocieties", "getLanguages", "resetLanguages"]),
    ...mapMutations("members", ["setSociety"]),
    imgSrc (imgName) {
      return remoteImg(imgName)
    },
    pushTo (to) {
      this.$router.push({ name: to })
    },
    registerMember () {
      this.loading = true
      // eslint-disable-next-line no-undef
      grecaptcha.ready(() => {
        // eslint-disable-next-line no-undef
        grecaptcha
          .execute(this.$config.GOOGLE_RECAPTCHA_SITE_KEY, {
            action: "signup"
          })
          // eslint-disable-next-line camelcase
          .then(recaptcha_token => {
            if (this.registered) {
              this.registered = false
              this.name_and_last_name = ""
              this.address = ""
              this.email = ""
              this.error = ""
              this.member = ""
              this.current_societies = []
              this.setSociety("")
              return
            }

            this.error = ""

            let data = {
              name_and_last_name: this.name_and_last_name,
              parents: this.current_societies.map(society => society.name),
              organization: this.member,
              email: this.email,
              address: this.address,
              language:
                this.language === ""
                  ? this.languages[0].alpha_2
                  : this.language.alpha_2,
              recaptcha_token
            }

            ApiCalls.signUp(data)
              .then(() => {
                this.loading = false

                this.registered = true
              })
              .catch(err => {
                this.loading = false

                this.error = err.error

                if (this.error.parent !== undefined) {
                  this.error.app = this.error.parent
                }
              })
          })
      })
    }
  }
}
</script>
